import { Card, Grid, Heading } from '@enterprise-ui/canvas-ui-react'
import { TloGroupSummary } from 'services/tloGroupSummary'

type Props = { summary: TloGroupSummary }

const format = (value: number) => value.toLocaleString()

const Metric = ({
  label,
  value,
  limit,
  overage,
}: {
  label: string
  value: number
  limit: number
  overage: number
}) => (
  <Grid.Item xs={4}>
    <div style={{ color: '#5c5c5c', fontSize: '12px' }}>{label}</div>
    <div
      data-testid={`tlo-summary-${label.toLowerCase().replace(/ /g, '-')}`}
      style={{
        color: overage > 0 ? '#c62828' : '#222',
        fontSize: '20px',
        fontWeight: 700,
      }}
    >
      {format(value)}
    </div>
    <small style={{ color: overage > 0 ? '#c62828' : '#5c5c5c' }}>
      {overage > 0 ? `Over by ${format(overage)}` : `Limit ${format(limit)}`}
    </small>
  </Grid.Item>
)

export const TloSummaryCard = ({ summary }: Props) => (
  <Card className="hc-pa-normal hc-mb-normal" data-testid="tlo-summary-card">
    <Heading size={6}>
      TLO {summary.tloRefId} — Total Across {summary.totalShipments} Shipments
    </Heading>
    <Grid.Container spacing="tight" align="center">
      <Metric
        label="Total Weight (lbs)"
        value={summary.totals.weight}
        limit={summary.limits.weight}
        overage={summary.overages.weight}
      />
      <Metric
        label="Total Cube (ft³)"
        value={summary.totals.cube}
        limit={summary.limits.cube}
        overage={summary.overages.cube}
      />
      <Metric
        label="Total Pallet Spaces"
        value={summary.totals.palletSpaces}
        limit={summary.limits.palletSpaces}
        overage={summary.overages.palletSpaces}
      />
      <Grid.Item xs={12}>
        <strong>Single truck limits</strong>
        <div>
          {format(summary.limits.weight)} lbs&nbsp;&nbsp;•&nbsp;&nbsp;
          {format(summary.limits.cube)} ft³&nbsp;&nbsp;•&nbsp;&nbsp;
          {format(summary.limits.palletSpaces)} pallet spaces
        </div>
      </Grid.Item>
    </Grid.Container>
  </Card>
)
